import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  FormControl,
  FormHelperText,
  MenuItem,
  Icon,
  Typography,
  TextField,
  Divider,
  Button,
} from '@material-ui/core';
import { addTag } from '@pingum/app-state-management/tagType/actions';

import {
  getColorForTagType,
  getIconForTagType,
} from '..';

const renderTagTypeMenuItem = (tagType, tagTypes) => (
  <MenuItem value={tagType} key={tagType.id}>
    <Icon
      style={{
        color: getColorForTagType(tagTypes, tagType.id),
        marginRight: 10,
      }}
    >
      {getIconForTagType(tagTypes, tagType.id)}
    </Icon>
    {tagType.name}
  </MenuItem>
);

export class CreateTagInlineComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTagType: {
        id: -1,
        name: 'Select a tag type',
      },
      tagName: props.inputValue,
      nameError: false,
    };
  }

  handleTagTypeChange = (e) => {
    this.setState({ selectedTagType: e.target.value });
  }

  handleNameChange = (e) => {
    const changedValue = e.target.value;
    const isValid
      = changedValue !== null
        && changedValue !== undefined
        && changedValue.length >= 2
        && changedValue.length <= 50;
    this.setState({
      tagName: changedValue,
      nameError: !isValid,
    });
  }

  allFieldsValid = () => {
    const {
      selectedTagType,
      tagName,
      nameError,
    } = this.state;
    return !nameError && tagName.length > 1 && selectedTagType.id >= 0;
  }

  saveTag = () => {
    const addTagRequest = {
      name: this.state.tagName,
      parentTagId: null,
    };
    this.props.addTag(this.state.selectedTagType.id, addTagRequest).then((newTag) => {
      this.props.onCancelAddTag();
      this.props.onAddTag(newTag);
    });
  }

  render() {
    const {
      selectedTagType,
      tagName,
      nameError,
    } = this.state;
    const {
      tagTypes,
      onCancelAddTag,
    } = this.props;

    return (
      <div style={{ padding: 8 }}>
        <Typography variant="caption">Create new tag</Typography>
        <Divider style={{ marginBottom: 8 }} />
        <TextField
          select
          style={{
            width: '50%',
            padding: 5,
          }}
          // margin="normal"
          SelectProps={{
            renderValue: (tagType) => (
              <div>
                <Icon
                  style={{
                    color: getColorForTagType(tagTypes, tagType.id),
                    marginRight: 10,
                    fontSize: 15,
                  }}
                >
                  {getIconForTagType(tagTypes, tagType.id)}
                </Icon>
                {tagType.name}
              </div>
            ),
          }}
          label="Tag Type"
          name="Tag Type"
          value={selectedTagType}
          onChange={this.handleTagTypeChange}
          helperText="Select the category to add this tag to?"
        >
          {
            tagTypes.map((tagType) => (
              renderTagTypeMenuItem(tagType, tagTypes)
            ))
          }
        </TextField>
        <FormControl
          style={{
            width: '50%',
            padding: 5,
          }}
        >
          <TextField
            error={nameError}
            variant="outlined"
            id="tag-name"
            label="Name"
            value={tagName}
            onChange={this.handleNameChange}
          />
          <FormHelperText>
            { nameError && 'Tag name must be between 2 and 50 characters in length'}
          </FormHelperText>
        </FormControl>

        <div style={{ textAlign: 'right' }}>
          <Button
            size="small"
            onClick={onCancelAddTag}
          >
            Cancel
          </Button>
          <Button
            size="small"
            onClick={this.saveTag}
            disabled={!this.allFieldsValid()}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

CreateTagInlineComponent.propTypes = {
  tagTypes: PropTypes.array,
  inputValue: PropTypes.string,
  onCancelAddTag: PropTypes.func,
  onAddTag: PropTypes.func,
  addTag: PropTypes.func,
};

CreateTagInlineComponent.defaultProps = {
  inputValue: '',
  tagTypes: [],
  onCancelAddTag: () => {},
  onAddTag: () => {},
  addTag: () => {},
};

export const mapDispatchToProps
  = (dispatch) => ({ addTag: (tagTypeId, request) => dispatch(addTag(tagTypeId, request)) });

export default connect(
  null,
  mapDispatchToProps,
)(CreateTagInlineComponent);
